'use strict';

import Actions from './actions';
import Button from '../../../components/form/button.jsx';
import ControlGroup from '../../../components/form/control-group.jsx';
import React from 'react';
import Spinner from '../../../components/form/spinner.jsx';
import TextControl from '../../../components/form/text-control.jsx';
import PropTypes from 'prop-types';

const propTypes = {
    loading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.string,
    hasError: PropTypes.object,
    help: PropTypes.object
};

class Forgot extends React.Component {
    constructor(props) {

        super(props);

        this.input = {};

    }

    componentDidMount() {

        if (this.input.email) {
            this.input.email.focus();
        }
    }

    componentWillUnmount() {

    }

    recover(event) {

        event.preventDefault();
        event.stopPropagation();

        Actions.forgotRecover({
            email: this.input.email.value()
        });
    }

    continue(event) {

        event.preventDefault();
        event.stopPropagation();
        Actions.forgotContinue();
    }

    cancel(event) {

        event.preventDefault();
        event.stopPropagation();
        Actions.forgotCancel();
    }

    render() {

        const alerts = [];

        if (this.props.success) {
            alerts.push(<div key="success" className="alert alert-success">
                If this email exists in our system a password recovery email has been sent. Please check your inbox for further instructions.
            </div>);
        }
        else if (this.props.error) {
            alerts.push(<div key="danger" className="alert alert-danger">
                {this.props.error}
            </div>);
        }

        let formElements;

        if (!this.props.success) {
            formElements = <fieldset>
                <TextControl
                    ref={(c) => (this.input.email = c)}
                    name="email"
                    label="Email"
                    hasError={this.props.hasError.email}
                    help={this.props.help.email}
                    disabled={this.props.loading}
                />
                <ControlGroup hideLabel={true} hideHelp={true}>
                    <Button
                        type="button"
                        onClick={this.recover.bind(this)}
                        inputClasses={{ 'btn-success': true }}
                        disabled={this.props.loading}>

                        Recover
                        <Spinner space="left" show={this.props.loading} />

                    </Button> <Button
                        type="button"
                        onClick={this.cancel.bind(this)}
                        inputClasses={{ 'btn-default': true }}
                        disabled={this.props.loading}>

                    Cancel
                    </Button>
                </ControlGroup>
            </fieldset>;
        }
        else {
            formElements = <fieldset>
                <Button
                    type="button"
                    onClick={this.continue.bind(this)}
                    inputClasses={{ 'btn-primary': true }}
                    disabled={this.props.loading}>

                        Continue
                </Button>
            </fieldset>;
        }

        return (
            <section className="sor sor-forgot">
                <h4 className="text-center">Recover Password</h4>
                <form>
                    {alerts}
                    {formElements}
                </form>
            </section>
        );
    }
}

Forgot.propTypes = propTypes;

export default Forgot;
